

import { mapMutations, mapGetters } from 'vuex';

import Template from 'components/templates/Navigation.vue';
import Navigation from 'components/mixins/Navigation.vue';
import ButtonBlock from 'components/blocks/Button.vue';
import ImageBlock from 'components/blocks/Image.vue';
import ExpandableBlock from 'components/blocks/Expandable.vue';

export default {
  block: 'navigation',
  data() {
    return {
      showGetStarted: false,
      active: null,
    }
  },
  mixins: [
    Template,
    Navigation
  ],
  components: {
    ButtonBlock,
    ImageBlock,
    ExpandableBlock,
  },
  computed: {
    ...mapGetters([
      'getStartedMenuOpen',
    ]),
  },
  methods: {
    ...mapMutations([
      'openGetStartedMenu',
    ]),
    toggleExpandable(index) {
      this.active = index;
    },
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/Navigation.vue